// extracted by mini-css-extract-plugin
export default {"modal":"KZ-z","error":"LZ-z","disabled":"MZ-z","footer":"NZ-z"};